import { Box, styled } from '@mui/joy';

export const Wrapper = styled(Box)({
  position: 'relative',
  height: '100%',
});

export const SubtitleWrapper = styled(Box)({
  display: 'flex',
  gap: 8,
  position: 'absolute',
  top: '-39px',
  right: 0,
});
